/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/ItemGridEditor.ts" />

namespace TabAurous.Inventory {

    import fld = CertificationReturnItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class CertificationReturnItemsEditor extends _Ext.ItemGridEditor<CertificationReturnItemsRow> {


        protected getColumnsKey() { return "Inventory.CertificationReturnItems"; }
        protected getDialogType() { return CertificationReturnItemsDialog; }
        protected getLocalTextPrefix() { return CertificationReturnItemsRow.localTextPrefix; }
        protected form: CertificationReturnItemsForm;

        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = false;
            return opt;
        }

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables 
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public canUpdate: number;
        public TransDate: Date;
        private GenSKU: boolean = false;
        isEditable: boolean;

        // #endregion

        // #region Constructor
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true, rowHeight: 30 });
            this.toolbar.findButton('add-button').find('.button-inner').text('New Product');
             
            var value = q.ToBool(TabAurous.GetConfigValue(1004));
            if (value == true)
                this.GenSKU = true;
            else
                this.GenSKU = false;

            this.isEditable = this.slickGrid.getOptions().editable;


            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as CertificationReturnDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);
                }
            })
        }
        // #endregion
        public getTotalRows() {
            return this.view.getItems().length;
        }
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
             
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var wt = ctx => ColumnFormatter.WeightFormatter(ctx, this);
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);

            var Department = Q.first(columns, x => x.field === fld.DepartmentId);
            Department.referencedFields = [fld.DepartmentId];
            Department.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.DepartmentId, OMS.DepartmentMasterRow.getLookup(), this);

            Q.first(columns, x => x.field === fld.Pieces).format = int;
            Q.first(columns, x => x.field === fld.Weight).format = wt;
           // Q.first(columns, x => x.field === fld.DiscountPer).format = num;
            Q.first(columns, x => x.field === fld.Discount).format = amt;
            Q.first(columns, x => x.field === fld.UnitRate).format = amt;

            if (!this.GenSKU)
                columns = columns.filter(x => x.field != 'SKU');

            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion

        // #region Common Functions 

        setMasterValues() {
            this.RateListId = (this.parentDialog as CertificationReturnDialog).RateListId;
            this.LaborListId = (this.parentDialog as CertificationReturnDialog).LaborMarkup;
            this.StoneMarkup = (this.parentDialog as CertificationReturnDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as CertificationReturnDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as CertificationReturnDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as CertificationReturnDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as CertificationReturnDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as CertificationReturnDialog).form.TransDate.valueAsDate;
            this.PartyId = parseInt((this.parentDialog as CertificationReturnDialog).form.PartyId.value);
            
        }

        public Editable() {
            this.isEditable = true;
        }
         
        public setEditValue(source: CertificationReturnRow, property) {
            super.setEditValue(source, property);
        }

        // **** to Call shortcut key in Main Window
        protected createToolbar(buttons: Serenity.ToolButton[]): void {
            var toolbarDiv = $('<div class="grid-toolbar"></div>').appendTo(this.element);
            this.toolbar = new Serenity.Toolbar(toolbarDiv, { buttons: buttons, hotkeyContext: document.getElementsByTagName('body')[0] });
        }

        // #endregion

        //#region  ItemGrid Inline Editor

        // **** Onclick Event ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);
            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            //To Set Master Product Image
            CertificationReturnDialog.image = item.ImageName;
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();
            if (target.hasClass('edit')) {
                if (this.isReadOnly) {
                    target.addClass('readonly');
                    target.blur();
                    q.Alert("View Mode", "Can not make changes in view mode", 2000, true);
                }
            }

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    if (this.isReadOnly) {
                        q.Alert("View Mode", "Can not make changes in view mode", 2000, true);
                        //Q.alert("Voucher is ReadOnly can not Delete!!")
                    }
                    else {
                        //TODO: Validate for TransItemID in RefTransItemID in Stock
                        q.information('Are you sure want to Delete?', '', true, () => {
                            var id = this.id(item);
                            let refid: any;
                            TabAurous.Stock.StockItemService.CheckItemTransaction(
                                {
                                    RefTransId: item.TransId,
                                    RefTransItemId: item.TransItemId,
                                    Line_No: (item.Line_No),
                                    ProductId: (item.ProductId)
                                }
                                , response => {
                                    refid = response.Entities
                                }, { async: false })
                            if (refid != null && refid.length > 0) {
                                if (refid[0].TransId != null || refid[0].TransId > 0) {
                                    Q.alert("This Item has been used in transactions Can Not Delete!");
                                    return;
                                }
                            }else
                                this.view.deleteItem(id);
                            
                        }, () => { });
                    }
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }

            if (target.hasClass('edit numeric')) {
                e.preventDefault();
                //TODO: Need to add System Parameter to enable disable blocking
                var input = $(e.target);
                if (input != undefined) {
                    if (this.isReadOnly) {
                        //Check Editable
                        target.addClass('readonly');
                        target.blur();
                        q.Alert("View Mode", "Can not make changes in view mode", 2000, true);
                    }
                    else if (!this.isReadOnly) {
                        target.removeClass('readonly');
                        var input = $(e.target);
                        var y = input.data();
                        if (y.field == "Weight" && item.ItemTypeId == 101 && item.HasBom) {
                            target.addClass('readonly');
                            target.blur();
                        }
                        else if (y.field == "UnitRate" && item.ItemTypeId == 101 && item.HasBom) {
                            target.addClass('readonly');
                            target.blur();
                        }
                        else if (y.field == "Pieces" && item.ItemTypeId == 104) {
                            target.addClass('readonly');
                            target.blur();
                        }
                    }
                }
                this.view.refresh();
            }
        }

        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Weight || field === fld.Discount || field === fld.UnitRate) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0 && item.ItemTypeId == 101) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.NetAmount * value;
                    item.Weight = (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = (item.NetWeight / item.Pieces) * value;
                    item.BOMDetails.forEach(function (x) {
                        var Pieces = (x.Pieces / item.Pieces) * value;
                        var Weight = (x.Weight / item.Pieces) * value;
                        if (x.CalcOnId == 3) {
                            x.BomAmount = x.BomRate * Pieces;
                        }
                        else {
                            if (x.ItemTypeId == 104)
                                x.BomAmount = x.BomRate * Weight * x.Purity;
                            else
                                x.BomAmount = x.BomRate * Weight;
                        }
                        x.Pieces = Pieces;
                        x.Weight = Weight;
                    })
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                }
                item[field] = value;
                
            }
            // **** Allow to Set Pcs to Zero for RM ****
            if (field === fld.Pieces && item.ItemTypeId != 101) {
                if (item.CalcOnId == 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = ((item.UnitRate + labr) / item.Pieces) * value;
                    item.NetAmount = Net;
                    var Discount = 0; //Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

            }

            // **** Allow to Set Weight for RM ****
            if (field === fld.Weight && !item.HasBom) {
                if (item.CalcOnId != 3) {
                    var labr = item.UnitLabour || 0;
                    var rate = item.UnitRate || 0;
                    if (item.ItemTypeId == 101 || item.ItemTypeId == 104) {
                        rate = item.UnitRate * item.Purity;
                    }

                    var Net = (rate + labr) * value;
                    item.NetAmount = Net;
                    var Discount = 0; //Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.NetWeight = value;
                    if (item.WstPer != null) {
                        item.WstWt = value * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

            }

            // **** Calculate Amount based on UnitRate and Weight or Pieces
            if (field === fld.UnitRate && item.ItemTypeId != 101) {
                if (item.CalcOnId != 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.Weight * value) + labr;
                    item.NetAmount = Net;
                    var Discount = 0; //Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;
                }


                if (item.CalcOnId == 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.Pieces * value) + labr;
                    item.NetAmount = Net;
                    var Discount = 0; //Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;
                }
                item[field] = value;
            }

            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                //item.DiscountPer = (value / item.NetAmount) * 100;
                item[field] = value;
            }

            // *** Calculate Discount % ***
            //if (field === fld.DiscountPer && value >= 0) {
            //    var Discount = (item.NetAmount * value) / 100
            //    item.GrossAmount = item.NetAmount - Discount;
            //    item.Discount = Discount;
            //    item[field] = value;
            //}

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;
            }

            this.view.updateItem(id, item);

            this.view.refresh();
            (this.parentDialog as CertificationReturnDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion

        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();

            //**** Master ****//
            buttons.push({
                title: "Select Items",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => {
                    var grid = Common.CertificationIssueSelectGrid;
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {
                        var filters: _Ext.SelectGridFilters = {
                            PartyId: this.PartyId
                        }

                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true,
                            preSelectedKeys: this.value.map(k => k.TransItemId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        //var ItemDetails = ItemGridHelper.SetReturnItemGrid(selectedItems2); 
                        this.setData(selectedItems2);
                    } 
                    pickerDialog.dialogOpen();
                },
                disabled: () => this.isReadOnly || this.readOnly
            });

             
            return buttons;
        }
        // #endregion

        // #region Set Data

        setData(Items: any[]) {
            var self = this;

            var ItemDetails = [];
            Items.forEach(function (Item: CertificationIssueItemsRow) {
                var ReturnItem: CertificationReturnItemsRow = {
                    ProductId: Item.ProductId,
                    AttributeId: Item.AttributeId,
                    Line_No: Item.Line_No,
                    PartyId: Item.PartyId,
                    SKU: Item.SKU,                    
                    DepartmentId: Item.DepartmentId,
                    ProductCode: Item.ProductCode,
                    ProductName: Item.ProductName,
                    ItemTypeId: Item.ItemTypeId,
                    CategoryId: Item.CategoryId,
                    ProductTypeId: Item.ProductTypeId,
                    SubCategoryId: Item.SubCategoryId,
                    BrandId: Item.BrandId,
                    SuperTypeId: Item.SuperTypeId,
                    CollectionId: Item.CollectionId,
                    ProductSizeId: Item.ProductSizeId,
                    UnitRate: Item.UnitRate,
                    UnitLabour: Item.UnitLabour,
                    Pieces: Item.Pieces,
                    Weight: Item.Weight,
                    OtherPieces: Item.OtherPieces,
                    OtherWeight: Item.OtherWeight,
                    StonePieces: Item.StonePieces,
                    StoneWeight: Item.StoneWeight,
                    NetWeight: Item.NetWeight,
                    NetAmount: Item.NetAmount,
                    GrossAmount: Item.GrossAmount,
                    DiamondPieces: Item.DiamondPieces,
                    DiamondWeight: Item.DiamondWeight,
                    CalcOnId: Item.CalcOnId,
                    BOMDetails: Item.BOMDetails, 
                    CompanyId: Item.CompanyId,
                    HSN: Item.HSN,
                    TaxCode: Item.TaxCode,
                    AckStatus: Item.AckStatus,
                    BagNo: Item.BagNo,
                    BagStatus: Item.BagStatus,
                    CertificateNo: Item.CertificateNo,
                    DiamondAmount: Item.DiamondAmount,
                    ImageName: Item.ImageName,
                    LotNo: Item.LotNo,
                    MetalAmount: Item.MetalAmount,
                    OtherAmount: Item.OtherAmount,
                    Remark: Item.Remark,
                    SpecialRemark: Item.SpecialRemark,
                    StoneAmount: Item.StoneAmount,
                    UnitCost: Item.UnitCost,
                    UserDescription: Item.UserDescription,
                    VoucherDate: Item.VoucherDate,
                    VoucherTypeId: Item.VoucherTypeId,
                    WstPer: Item.WstPer,
                    WstWt: Item.WstWt,
                    Studded: Item.Studded,
                    Discount: Item.Discount,
                    DeliveryDate: Item.DeliveryDate,
                    TransId: Item.TransId,
                    TransItemId: Item.TransItemId,

                    KaratId: Item.KaratId,
                    MetalColorId: Item.MetalColorId,
                    QualityId: Item.QualityId,
                    SieveId: Item.SieveId,
                    ShapeId: Item.ShapeId,
                    StoneColorId: Item.StoneColorId,
                    StoneSizeId: Item.StoneSizeId,
                    StockAllocation: Item.StockAllocation,
                    StoneCutId: Item.StoneCutId,
                    StonePolishId: Item.StonePolishId,
                    StoneSymmetryId: Item.StoneSymmetryId,
                    StoneFluorescenceId: Item.StoneFluorescenceId,
                    StoneCuletId: Item.StoneCuletId,
                    StoneGirdleId: Item.StoneGirdleId,
                    StoneTable: Item.StoneTable,
                    StoneDepth: Item.StoneDepth,
                    Lab: Item.Lab,
                    Purity: Item.Purity,
                    PureWeight: Item.PureWeight,
                    HasBom: Item.HasBom,
                    RefNo: Item.RefNo,
                    RefTransId: Item.TransId,
                    RefTransItemId: Item.TransItemId, 
                    RefVoucherId: Item.VoucherTypeId,
                    ProcessId:Item.ProcessId
                }
                ItemDetails.push(ReturnItem);
            });

            for (let Itemdetail of ItemDetails) {
                var processid = Itemdetail.ProcessId;
                if (processid != null) {
                    let process;
                    OMS.ProcessMasterService.Retrieve({ EntityId: processid }, response => { process = response.Entity }, { async: false });
                    var ItemLabor: CertificationReturnLaborRow[] = RateHelper.ApplyPurchseLabour(
                        Itemdetail, [process],
                        self.LaborListId, self.LaborMarkup, self.TransDate)
                    Itemdetail.LaborDetails = ItemLabor;
                }
                Itemdetail[this.getIdProperty()] = "`" + this.nextId++; 
                this.view.addItem(Itemdetail);
            }
        }

        // #endregion


    }
}